import React, { useState, useEffect } from 'react';
import { axiosInstance } from '../../utils';
import user from "../../assets/imgs/user.jpeg";

const UserProfile = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    getProfile();
  }, []);

    const token = localStorage?.getItem("token");
  

const getProfile = async () => {
  try {
    await axiosInstance.post("/api/admin/view-profile", "",{
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    .then(res =>  { setData(res.data?.data);
      
    })
    .catch(err => console.log(err))
  } catch (error) {
    console.log(error);
  }
}

  return (
    <section className='container py-10'>
      <div className='p-4 bg-white rounded-lg max-h-max border-t-8 border-t-primary-yellow-500'>
        <p className='border-b-2 border-b-secondary-n-50 border-dashed pb-3 mb-6 font-poppins text-lg font-medium text-secondary-n-800'>Personal Information</p>
       
        {/* <div className='w-24 h-28  pb-5 '>
          <img  src={user} alt='user avatar' className='w-full h-full rounded-full' />
        </div> */}

        <div className='grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-2 grid-cols-1 gap-6'>
          
          
            <div className='space-y-2'>
              <label htmlFor='userId' className='font-poppins font-medium text-base text-secondary-n-500'>User ID:</label>
              <input type='text' value={data?.userId}  className='border-b-2 border-b-secondary-n-50  w-full outline-none' readOnly />
            </div>

            <div className='space-y-2'>
              <label htmlFor='username' className='font-poppins font-medium text-base text-secondary-n-500'>User name:</label>
              <input type='text' value={data?.username}  className='border-b-2 border-b-secondary-n-50  w-full outline-none' readOnly />
            </div>

            <div className='space-y-2'>
              <label htmlFor='email' className='font-poppins font-medium text-base text-secondary-n-500'>Email:</label>
              <input type='email' value={data?.email} className='border-b-2 border-b-secondary-n-50  w-full outline-none' readOnly />
            </div>

            <div className='space-y-2'>
              <label htmlFor='contactNumber' className='font-poppins font-medium text-base text-secondary-n-500'>Contact Number:</label>
              <input type='tel' value={data?.contactNumber} className='border-b-2 border-b-secondary-n-50  w-full outline-none' readOnly />
            </div>
          
        </div>
      </div>
    </section>
  )
}

export default UserProfile